import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'material-ui/Drawer';
import MenuItem from 'material-ui/MenuItem';
import AppBar from 'material-ui/AppBar';
import FlatButton from 'material-ui/FlatButton';
import { withRouter } from 'react-router-dom';

import logoSetrem from '../../assets/logo-setrem-nova.png';
import Container from '../../Container';
import { Utils, eventEmitter } from '../../services';

const styles = {
    content: {
        paddingLeft: 350,
    },
    appBarContent: {
        paddingLeft: 374,
    },
    selectedMenuItem: {
        backgroundColor: 'rgba(0, 0, 0, 0.0980392)',
        margin: '0 auto',
    },
    buttonMenuHome: {
        height: 64,
    },
};

const isSelectedMenuItem = (pathName) => {
    if (window.location.pathname === pathName) {
        return styles.selectedMenuItem;
    }
    return {};
};

const menusPublicos = [{ URL: '/login', NOME: 'Login' }];

class PublicMaster extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openMenu: true,
            dockedMenu: true,
            menus: [],
        };
        document.title = `${props.title} - Eventos Científicos - SETREM`;
    }

    async componentWillMount() {
        window.addEventListener('resize', () => this.onResize());
        const menus = menusPublicos.concat(await Utils.getMenus());
        this.setStateCustom({ menus }, () => this.onResize(true));
    }

    componentDidMount() {
        this.onResize(true);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', () => this.onResize());
    }

    onResize(isOnLoad) {
        if (document.body.clientWidth <= 768) {
            this.changeDrawerStatus(
                isOnLoad ? false : this.state.openMenu,
                false,
            );
        } else {
            this.changeDrawerStatus(
                isOnLoad ? true : this.state.openMenu,
                true,
            );
        }
    }

    setStateCustom(data, callback = () => {}) {
        if (this.publicMasterRef) {
            this.setState(data, callback);
        }
    }

    changeDrawerStatus(openMenu, dockedMenu) {
        this.setStateCustom({ openMenu, dockedMenu });
        eventEmitter.emmit('change-drawer', { openMenu, dockedMenu });
    }

    render() {
        const { title, children, history } = this.props;

        const { openMenu, dockedMenu, menus } = this.state;

        return (
            <Container
                ref={(ref) => {
                    this.publicMasterRef = ref;
                }}
                history={history}
            >
                <AppBar
                    title={title}
                    onLeftIconButtonClick={() =>
                        this.changeDrawerStatus(!openMenu, dockedMenu)
                    }
                    className="nav-bar-fixed"
                    style={openMenu && dockedMenu ? styles.appBarContent : {}}
                />
                <Drawer
                    width={350}
                    open={openMenu}
                    docked={dockedMenu}
                    disableSwipeToOpen
                    onRequestChange={(open) =>
                        this.changeDrawerStatus(open, dockedMenu)
                    }
                >
                    <AppBar
                        showMenuIconButton={false}
                        titleStyle={{ flex: 0 }}
                        style={{ justifyContent: 'center' }}
                    >
                        <FlatButton
                            onClick={() => history.push('/')}
                            style={styles.buttonMenuHome}
                            disableTouchRipple
                        >
                            <img
                                src={logoSetrem}
                                className="logo"
                                alt="Logo SETREM"
                                style={{ margin: '0 auto' }}
                            />
                        </FlatButton>
                    </AppBar>
                    <div>
                        {menus.map((menu) => (
                            <MenuItem
                                key={menu.URL}
                                onClick={() => history.push(menu.URL)}
                                style={isSelectedMenuItem(menu.URL)}
                            >
                                {menu.NOME}
                            </MenuItem>
                        ))}
                        {/* <MenuItem containerElement={<Link to="/eventos-finalizados" />} style={isSelectedMenuItem('/eventos-finalizados')}>Anais e Certificados</MenuItem>
                        <MenuItem containerElement={<Link to="" />} style={isSelectedMenuItem('/certificado-ouvinte')}>Inscrever-se de ouvinte</MenuItem>
                        <MenuItem containerElement={<Link to="" />} style={isSelectedMenuItem('/certificado-ouvinte')}>Certificado de ouvinte</MenuItem> */}
                    </div>
                </Drawer>
                <div
                    className="content"
                    style={openMenu && dockedMenu ? styles.content : {}}
                >
                    {children}
                </div>
            </Container>
        );
    }
}

PublicMaster.propTypes = {
    title: PropTypes.string.isRequired,
    history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
        .isRequired,
};

export default withRouter(PublicMaster);
